//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Ingredients',
  props: {
    ingredients: {
      type: Object,
      default: () => {}
    },
    noIngredientMarginBottom: Boolean
  },
  data() {
    return {
      invalidNutritionImage: false
    };
  },
  computed: {
    mobileAndPhablet() {
      return this.$mq === 'mobile' || this.$mq === 'phablet';
    },
    productName() {
      return (this.ingredients || {}).productName || '';
    },
    keyIngredients() {
      return (this.ingredients || {}).keyIngredients || [];
    },
    activeIngredients() {
      return (this.ingredients || {}).activeIngredients || '';
    },
    inactiveIngredients() {
      return (this.ingredients || {}).inactiveIngredients || '';
    },
    nutritionInformationImage() {
      return (this.ingredients || {}).nutritionInformationImage || {};
    },
    otherIngredients() {
      return (this.ingredients || {}).otherIngredients || '';
    },
    allIngredients() {
      return (this.ingredients || {}).allIngredients || '';
    },
    ingredientDisclaimers() {
      return (this.ingredients || {}).ingredientDisclaimers || [];
    },
    nutritionFacts() {
      return (this.ingredients || {}).nutritionFacts || {};
    }
  }
};
